import homepageAlert from 'assets/brands/cpc/js/page/homepage/alert'

document.addEventListener('DOMContentLoaded', function () {
  homepageAlert()
})
